addEventListener("DOMContentLoaded", () => {
  
  
  document.querySelectorAll(".marquee").forEach(marquee => {
    if ("infinite" in marquee.dataset) {
      const original = Array.from(marquee.children)
      for (let i = 0; i < 39; i++) {
        original.forEach(child => marquee.appendChild(child.cloneNode(true)))
      }
      if (marquee.dataset.speed) {
        marquee.dataset.speed = parseFloat(marquee.dataset.speed) * 40
      } else {
        marquee.dataset.speed = 15 * 40
      }
    }
    const div = document.createElement("div")
    div.className = "marquee-sub"
    div.append(...marquee.children)
    marquee.append(div)
    marquee.append(div.cloneNode(true))
    const measure = div.cloneNode(true)
    measure.classList.add("marquee-measure")
    marquee.append(measure)
    if (marquee.dataset.speed) {
      marquee.dataset.marquee = Math.random()
      const style = document.createElement("style")
      style.textContent = `
        [data-marquee="${marquee.dataset.marquee}"].marquee.scrolling .marquee-sub {
          animation: marquee ${parseFloat(marquee.dataset.speed)}s linear infinite;
        }
      `
      document.body.appendChild(style)
    }
    let paused = false
    if ("pausable" in marquee.dataset) {
      const pause = () => marquee.querySelectorAll(".marquee-sub").forEach(e => e.style.animationPlayState = "paused")
      const resume = () => marquee.querySelectorAll(".marquee-sub").forEach(e => e.style.animationPlayState = "running")
      marquee.addEventListener("mouseenter", pause)
      marquee.addEventListener("mouseleave", () => {
        paused = false
        resume()
      })
      marquee.addEventListener("touchstart", e => {
        paused = !paused
        if (paused) pause()
        else resume()
      })
    }
    marquee.classList.add("initialised")
    const adjust = () => marquee.classList.toggle("scrolling", measure.clientWidth > marquee.clientWidth)
    setTimeout(adjust, 0)
    window.addEventListener("resize", adjust)
  })

  // Loader Button

  class LoaderButton extends HTMLElement {
    static get observedAttributes() {
      return ["loading"]
    }
  
    get loading() {
      return this.hasAttribute("loading")
    }
  
    set loading(value) {
      this.toggleAttribute("loading", !!value)
    }
  
    connectedCallback() {
      this.classList.add("ante-button")
      this.addEventListener("click", e => {
        if (this.loading) e.stopImmediatePropagation()
      }, true)
    }
  
    attributeChangedCallback() {
      this.classList.toggle("loading", this.loading)
    }
  }
  
  customElements.define("loader-button", LoaderButton)

  // Page Width

  function updatePageWidth() {
    document.documentElement.style.setProperty("--page-width", `${document.documentElement.clientWidth}px`)
  }
  
  updatePageWidth()
  window.addEventListener("resize", updatePageWidth)

  // Modals

  const modals = document.createElement("div")
  modals.id = "modals"
  document.body.append(modals)
  
  function makeModal(title, content, id) {
    const container = document.createElement("div")
    if (id) {
      container.id = id
    }
    container.classList.add("modal-container")
    container.innerHTML = `
      <div class="modal-element">
        <div class="modal-title-row">
          <div class="modal-title">${title ?? "Modal"}</div>
          <svg width="44" height="44" viewBox="0 0 18 18" fill="none">
            <path d="M2.89062 14.5066L14.5066 2.89062M15.0475 14.5066L3.43155 2.89062" stroke="var(--color-text-light)" stroke-width="1.29691"/>
          </svg>
        </div>
        <div class="modal-contents"></div>
      </div>
    `
    const contents = container.querySelector(".modal-contents")
    if (typeof content === "string") {
      contents.innerHTML = content
    } else {
      contents.append(...content)
    }
    return container
  }
  
  function handleModal(modal, close, func) {
    modal.querySelector("svg").addEventListener("click", close)
    let down
    modal.addEventListener("mousedown", e => down = e.target)
    modal.addEventListener("mouseup", e => {
      if (down === e.target && e.target.classList.contains("modal-container")) {
        close()
      }
    })
    modals.append(modal)
    if (func) {
      const modalElement = modal.querySelector(".modal-element")
      modalElement.close = close
      func(modalElement)
    }
  }
  
  document.querySelectorAll(".modal").forEach(e => {
    const modal = makeModal(e.dataset.title, e.children, e.dataset.modalId ?? e.dataset.trigger + "-modal")
    handleModal(modal, () => modal.classList.remove("open"))
    e._modal = modal
  })
  
  document.addEventListener("click", e => {
    document.querySelectorAll(".modal").forEach(el => {
      if (e.target.closest(`.${el.dataset.trigger}`)) {
        modals.append(el._modal)
        setTimeout(() => el._modal.classList.add("open"), 0)
      }
    })
  })
  
  document.querySelectorAll("[data-modal]").forEach(el => {
    const modal = makeModal(
      el.dataset.modalTitle,
      el.dataset.modal,
      el.dataset.modalId
    )
  
    handleModal(modal, () => {
      modal.classList.remove("open")
      const code = el.getAttribute("data-modal-close")
      if (code) Function(code).call(el._modal)
    })
  
    el._modal = modal
  
    el.addEventListener("click", () => {
      modals.append(modal)
      setTimeout(() => {
        modal.classList.add("open")
        const code = el.getAttribute("data-modal-open")
        if (code) Function(code).call(el._modal)
      }, 0)
    })
  })
  
  function showModal(title, content, func, id) {
    const modal = makeModal(title, content, id)
    handleModal(modal, () => {
      modal.classList.remove("open")
      setTimeout(() => modal.remove(), 150)
    }, func)
    setTimeout(() => modal.classList.add("open"), 0)
  }

  window.showModal = showModal
})